module.exports = __webpack_public_path__ + "static/media/labding-banner.e6609cf5.png";